export default __webpack_public_path__ + "static/media/clearcutlandingpage.c62d41e6.jpg";